/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { Modal, Spinner } from "react-bootstrap";
import "./WnbModalAlert.css";

const WnbModalLoading = (props) => {
  const { showAlert, message } = props;

  return (
    <Modal show={showAlert} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Please Wait</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex align-items-center gap-3">
        <Spinner animation="border" role="status" />
        <span>{message || "Processing your request..."}</span>
      </Modal.Body>
    </Modal>
  );
};

export default WnbModalLoading;
